import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconBulb,
  IconUser,
  IconUsers,
  IconRoadSign,
} from '@tabler/icons-react';

const privateCloudFeatures: FeatureData[] = [
  {
    title: '',
    description: '',
    icon: <IconBulb size={24} />,
    key: 'features.privateCloud.feature1'
  },
  {
    title: '',
    description: '',
    icon: <IconUser size={24} />,
    key: 'features.privateCloud.feature2'
  },
  {
    title: '',
    description: '',
    icon: <IconUsers size={24} />,
    key: 'features.privateCloud.feature3'
  },
  {
    title: '',
    description: '',
    icon: <IconRoadSign size={24} />,
    key: 'features.privateCloud.feature4'
  },
];

export default privateCloudFeatures; 